module.exports = __webpack_public_path__ + "static/img/miles_pictgrid8_960x858.f712eb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid8_960x858.jpg
// module id = B+3Z
// module chunks = 0